(function () {
  var COOKIE_DAYS = 14;
  var COOKIE_PAID = 'partner_ads_paid';
  var COOKIE_PACID = 'partner_ads_pacid';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + date.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function captureParams() {
    var params = new URLSearchParams(window.location.search);
    var paid = params.get('pa-partnerid');
    var pacid = params.get('pacid');
    if (paid && pacid) {
      setCookie(COOKIE_PAID, paid, COOKIE_DAYS);
      setCookie(COOKIE_PACID, pacid, COOKIE_DAYS);
    }
  }

  function syncCartAttributes() {
    var paid = getCookie(COOKIE_PAID);
    var pacid = getCookie(COOKIE_PACID);
    if (!paid || !pacid) return;

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          partner_ads_paid: paid,
          partner_ads_pacid: pacid
        }
      })
    }).catch(function () {});
  }

  function init() {
    captureParams();

    var paid = getCookie(COOKIE_PAID);
    if (!paid) return;

    if (window.Shopify && window.Shopify.customerPrivacy) {
      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        syncCartAttributes();
      }
    } else {
      syncCartAttributes();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('visitorConsentCollected', function () {
    if (window.Shopify.customerPrivacy.marketingAllowed()) {
      syncCartAttributes();
    }
  });
})();
